import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import MonthSelect from "@/components/MonthSelect";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadStatement, monthOptions } from "@/lib/statements";

export default function StatementsCard({ testidPrefix = "statements" }) {
  const options = monthOptions(12);  const [ym, setYm] = useState(options[0].value);
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const [y, m] = ym.split("-");
      await downloadStatement(Number(y), Number(m));
      toast.success("Statement downloaded");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not download statement");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card className="border-slate-200">
      <CardHeader>
        <CardTitle className="font-display text-xl">Monthly statements</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-end gap-3">
          <div className="flex-1">
            <label className="text-sm font-medium text-slate-700">Month</label>
            <div className="mt-2">
              <MonthSelect value={ym} onChange={setYm} testid={`${testidPrefix}-month-select`} className="w-full" />
            </div>
          </div>
          <Button
            onClick={download}
            disabled={busy}
            data-testid={`${testidPrefix}-download-btn`}
            className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90"
          >
            {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <FileDown className="h-4 w-4 mr-2" />}
            Download PDF
          </Button>
        </div>
        <p className="text-xs text-slate-500">
          Includes every ended call in the selected month with per-minute billing totals.
        </p>
      </CardContent>
    </Card>
  );
}
